import axios from 'axios';
import { Message } from 'element-ui';
import store from '@/store';
import { getToken } from '@/api/auth';
import env from '@/api/env';

const service = axios.create({
  baseURL: env.gsServer,
  withCredentials: false, // send cookies when cross-domain requests
  timeout: 60000 // request timeout
});

// request interceptor
service.interceptors.request.use(
  config => {
    config.headers['X-ACCESS-TOKEN'] = getToken();
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data;
    if(res.code !== 200 && res.code !== 204 && response.status !== 204) {
      if(res.code === 401) { // 登陆已经失效
        store.dispatch('user/resetToken').then(() => {
          location.reload();
        });
      }
      return Promise.reject(new Error(res.message || 'Error'));
    } else {
      return res && res.data;
    }
  },
  error => {
    if(error && error.response && error.response.status === 401) { // 登陆已经失效
      Message({
        message: '您的登陆已失效，请重新登陆',
        type: 'error',
        duration: 5 * 1000
      });
      return store.dispatch('user/resetToken').then(() => {
        location.reload();
      });
    }
    if(error && error.response && error.response.data) {
      return Promise.reject(error.response.data);
    }
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;
